/** What sits between the program and the community in a community page title. */
export const COMMUNITY_TITLE_SEPARATOR = ' - ';

/**
 * The parts of a community page title, in display order: the container
 * (program) first, then the feed sub-space's own name — e.g. `RYC® Pro Training
 * 2026 - Community` (ClickUp 86e3bna8t). `program` is null when the container is
 * unknown (legacy routes that load the feed without its parent).
 *
 * Callers that have room for markup render each part in its own `nowrap` span
 * with the separator between them, so a narrow phone breaks only at the
 * separator and neither name is ever split mid-phrase. Both names come from the
 * space catalog and may carry inline markup (e.g. `<sup>®</sup>`), so they are
 * rendered as sanitized HTML.
 */
export const communityTitleParts = (
  feedName: string | null | undefined,
  containerName?: string | null,
): { program: string | null; community: string } => ({
  program: containerName?.trim() || null,
  community: feedName?.trim() ?? '',
});

/** The same title as one string, for places that take plain text. */
export const formatCommunityTitle = (feedName: string | null | undefined, containerName?: string | null): string => {
  const { program, community } = communityTitleParts(feedName, containerName);
  return program && community ? `${program}${COMMUNITY_TITLE_SEPARATOR}${community}` : program || community;
};
